export default "__VITE_ASSET__YRZNBhLP__"